import React, { useState } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function BookWithTokenModal({
  cancelModal,
  profile,
  product,
  date,
  event,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [complete, setComplete] = useState(false);
  const { user } = useAuthContext();
  const [errorMessage, setErrorMessage] = useState("");

// styled


  const handleConfirm = async () => {
    try {
      setIsLoading(true);
  
      const createBooking = {
        appUserId: profile.appUserId,
        eventId: event.id,
        bookingProfileId: profile.id,
        productId: product.id,
        date,
      };
  
      const bookingResponse = await axios.post(
        `${ApiConnectionString}/api/OwnerBookingTokens`,
        createBooking,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
  
      if (bookingResponse.status === 200) {
        setComplete(true);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setErrorMessage(error.response.data);
      } else {
        console.error("Error during booking:", error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  if(isLoading){
    return (
        <div className="send-modal-overlay">
          <div className="send-modal">
          <LoadingSpinner />
          
          </div>
        </div>
      );
  }else{
    if(complete){
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
          <div className="blueBanner">
          <p className="fw-bold m-2 p-2 fontSize20">Booking Complete</p>
    

        </div>
        <p>{profile.firstName} {profile.lastName} ({profile.username}) is now booked into {event.name} on {event.day}, {date}, from {event.timeIn} to {event.timeOut}</p>
            <div className="send-modal-footer">
            <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Close
                </button>
            </div>
          </div>
        </div>
      );
    }else{
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
          <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button>
          <div className="blueBanner">
          <p className="fw-bold m-2 p-2 fontSize20">Booking</p>
        </div>
        <div className="d-flex">
            <span className="red-text">Customer</span>
            <p className="mx-3">
            {profile.firstName} {profile.lastName} ({profile.username})
            </p>
          </div>
          <div className="d-flex">
            <span className="red-text">Package</span>
            <p className="mx-3">
         
            </p>
          </div>
          <div className="d-flex">
            <span className="red-text">Event</span>
            <p className="mx-3">
            {event.name}
            </p>
          </div>
          <div className="d-flex">
            <span className="red-text">Day</span>
            <p className="mx-3">
            {event.day}
            </p>
          </div>
          <div className="d-flex">
            <span className="red-text">Date</span>
            <p className="mx-3">
            {date}
            </p>
          </div>
          <div className="d-flex">
            <span className="red-text">Time</span>
            <p className="mx-3">
            {event.timeIn} to {event.timeOut}
            </p>
          </div>
        <p>Are you sure you want to book {profile.firstName} {profile.lastName} ({profile.username}) into {event.name} on {event.day}, {date}, from {event.timeIn} to {event.timeOut}?</p>

          
            {errorMessage && <p className="text-danger">{errorMessage}</p>}
            <div className="send-modal-footer">
              <button className="saveChanges-button mx-3" onClick={handleConfirm}>
              Confirm
              </button>
              <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>
            </div>
          </div>
        </div>
      );
    }
  }


}
